import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["getlastdate", "assistantpersonne", "assistantdate", "assistantfacturation","referenceetablissement"]

  static values = {}

  // Called when the controller connects to the DOM
  connect() {
    this.factureInstances = [];
    this.initializeFactures();
    this.setupObserver()
  }

  initializeFactures(){
    this.getlastdateTargets.forEach(element => {
        this.initializeGetLastDate(element)
      })
    this.assistantpersonneTargets.forEach(element => {
      this.initializeAssistantPersonne(element)
    })
    this.assistantdateTargets.forEach(element => {
      this.initializeAssistantDate(element)
    })
    this.assistantfacturationTargets.forEach(element => {
      this.initializeAssistantFacturation(element)
    })

    this.referenceetablissementTargets.forEach(element => {
      console.log('found one')
      this.initializeReferenceEtablissement(element)
    })
  }

  disconnect() {
     this.factureInstances = []
 
     if (this.observer) {
       this.observer.disconnect()
     }     
  }  

  isElementInitialized(element) {
    // Check if the element is already in the instances array
    return this.factureInstances.some(instance => 
      instance.element === element
    )
  }    

  setupObserver() {
    // Create a new MutationObserver
    this.observer = new MutationObserver(mutations => {
      let needsInitialization = false
      
      // Check if any mutations added nodes to the DOM
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          needsInitialization = true
          break
        }
      }
      
      // If new nodes were added, check for new select targets
      if (needsInitialization) {
        this.initializeFactures();
      }
      this.autofill_date_debut()
    })
    
    // Start observing the entire element that contains this controller
    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    })
  } 
  
  initializeGetLastDate(element){
    if (this.isElementInitialized(element)) {return;}
    element.addEventListener('keydown', function(event) {
        if(event.which == 32){
            var patient_id = $('#' + event.target.id).closest('.fields').find('select.selectizecreate.personne_patients_affichage').val();
            if (!patient_id){
              patient_id = $('#' + event.target.id).closest('.fields').find('select.selectizecreate.personnes_affichage').val();
              if (patient_id)
                patient_id = patient_id[0].replace(/ /g,'').split(',')[1];
            }
      
            var bd_target = "";
            var bd_target_regex = event.target.className.match(/odd-[^\s]+/);
      
            if (bd_target_regex && patient_id){
              bd_target = bd_target_regex[0].replace('odd-','');
      
              $.ajax({
                method: 'GET',
                url: '/obtenir_derniere_date',
                data: { patient_id: patient_id,
                        bd_target: bd_target},
                dataType: 'json',
                success: function(response){
                  $('#' + event.target.id).datepicker('setDate', response);
                  return;
                },
                error:  function(response){
                    alert("Aucun date de " + bd_target + " antérieur présente à l'historique.");
                    return;
                }
              });
            }
          }
    });
    // Store the instance and configuration for later reference
    this.factureInstances.push({ element: element})    
  }
  
  initializeAssistantPersonne(element){
    if (this.isElementInitialized(element)) {return;}
    
    /* currently unused
    element.selectize.on("change", function(value) {
      var $this = $(this);
      $.ajax({
        method: 'GET',
        url: '/assistant_personne',
        data: { signature: value},
        dataType: 'json',
        success: function(response){
          console.log($this)
          console.log(response)
          $this.parent().parent().find("#assistant-personne").empty();
          $this.parent().parent().find("#assistant-personne").append(response);
          return;
        }
      });
    });
    */

    element.nextElementSibling.querySelector('.selectize-input input').addEventListener('keydown', function(event) {
      if (!(event.which == 37 || event.which == 39)) return;
      event.target.closest('.form-group').nextElementSibling.click()
    });
    // Store the instance and configuration for later reference
    this.factureInstances.push({ element: element})  
  }

  initializeAssistantDate(element){
    if (this.isElementInitialized(element)) {return;}
    $(element).on('changeDate', function(event) {
        $.ajax({
          method: 'GET',
          url: '/assistant_date',
          data: { date_service: event.target.value,
                  profil_etablissement_id: $('select[id$=profil_etablissement_id]').val()},
          dataType: 'json',
          success: function(response){
            $("#assistant-date").empty();
            $("#assistant-date").append(response);
            $(".assistant-date .assistant-pill").tooltip();//TODO Add ID so multi line in rfp facture will display everywhere
            return;
          }
        });
    });
    // Store the instance and configuration for later reference
    this.factureInstances.push({ element: element})  
  }
  
  initializeAssistantFacturation(element){
    if (this.isElementInitialized(element)) {return;}
    let timeout = null;
    function assistant_handler(event) {
      if($('#' + event.target.id).hasClass("assistant-animation") || event.target.value==null || event.target.value=="" ){
        return;
      }
      clearTimeout(timeout);
      $("#assistant-icon").addClass("assistant-animation");
      timeout = setTimeout(function () {
        var date_service = (new Date).toISOString().split('T',1).join();
        var personnes = [];

        if($('#' + event.target.id).hasClass("rapideacte")){
          date_service = $('#date_service-_d').val();
          personnes = $('#facture_personne_id-').val();
        }

        if($('#' + event.target.id).hasClass("grille_cell")){
          var date = new Date($('#grille-date_debut_d').val());
          var add_day = parseInt($('#' + event.target.id).attr('id').split('-')[4]);
          date.setDate(date.getDate() + add_day);
          date_service = date.toISOString().split('T',1).join();
          personnes = $('#' + event.target.id).closest(".fields").find("select.personnes_affichage option:selected").map(function() {return $(this).val();}).get();
        }
        $.ajax({
          url: '/rapidacte_assistant',
          type: 'GET',
          data: { ligne_facturation: event.target.value,
                  position: event.target.selectionStart,
                  date_service: date_service,
                  personnes: personnes}
        });
      }, 1000);
    };

    element.addEventListener('keyup', assistant_handler);
    element.addEventListener('click', assistant_handler);
    // Store the instance and configuration for later reference
    this.factureInstances.push({ element: element})      
  }


  initializeReferenceEtablissement(element){
    if (this.isElementInitialized(element)) {return;}
    const elementId = element.selectize.$input.attr('id')
    element.selectize.on("change", function(value) {
      var liste_no_id = elementId.replace(/etablissement(?!.*?etablissement)/, "liste_no");
      var secteur_activite_id = elementId.replace(/etablissement(?!.*?etablissement)/, "secteur_activite_id");
      var no_lieu_id = elementId.replace(/etablissement(?!.*?etablissement)/, "no_lieu");      
      $.ajax({
        url: '/filtre_par_etablissement',
        type: 'GET',
        data: { etablissement: value,
                liste_no_id: liste_no_id,
                no_lieu_id: no_lieu_id,
                secteur_activite_id: secteur_activite_id
              }
      });
  });

    // Store the instance and configuration for later reference
    this.factureInstances.push({ element: element})      
  }

  assistant_rapidacte(){
    $('.date_service_d:not(.bind_datepicker)').datepicker({orientation: 'bottom auto', showOnFocus: true});
    $(".date_service_d:not(.bind_datepicker)").addClass("bind_datepicker").keydown(function(event) {
      if(event.which == 32)
        $(this).data("datepicker").show()
    });
  }

  select_mutation(event){
    const mutation_code = event.srcElement.dataset.factureMutationcode;
    const ligne_facturation = $('.ligne_facturation_assistant.selected-cell').val()
    if(ligne_facturation==null || ligne_facturation==""){
      $('.ligne_facturation_assistant.selected-cell').val(mutation_code)
    }else{
      $('.ligne_facturation_assistant.selected-cell').val(ligne_facturation+','+mutation_code)
    }
    $('.ligne_facturation_assistant.selected-cell').click()
  }

  autofill_date_debut(){
    var nb_date_debut_d = $('.date_debut_d').length;
    if (nb_date_debut_d > 1
        && $('.date_debut_d').last().val() == ''
        && $('.date_debut_d')[nb_date_debut_d-2].value
        && !$('.date_debut_d')[nb_date_debut_d-1].value)
        {
          $('.date_debut_d').last().val($('.date_debut_d')[nb_date_debut_d-2].value)
        }
  }

  change_datepicker(event){
    const $src_element = event.srcElement.closest('a');
    const nb_day = parseInt($src_element.dataset.factureNbday);
    const target_id = $src_element.dataset.factureTargetid;
    const $date_element = $('#' + target_id);

    var new_date = $date_element.datepicker('getDate');
    new_date.setDate(new_date.getDate() + nb_day);
    $date_element.datepicker('setDate',new_date);
  }

  toggle_attr_personne(event){
    //attr-personne cnesst_d
    const iconElement = event.target.closest('.select-personne').querySelector('.icon-plus-personne');
    const nextElement = iconElement.closest('.select-personne').nextElementSibling;
    const tdParent = event.target.closest('td');


    if (iconElement.classList.contains("attr-display")){
        iconElement.classList.remove('attr-display');
        iconElement.classList.remove('fa-minus');
        iconElement.classList.add('fa-plus');
        $(nextElement).hide(200)
      }
      else{
        iconElement.classList.add('attr-display');
        iconElement.classList.add('fa-minus');
        iconElement.classList.remove('fa-plus');
        $(nextElement).show(200)
        // From the td parent, find the input with class "cnesst_d"
        if (tdParent) {
          const input = tdParent.querySelector('input.debut_admission_d');         
          if (input) { setTimeout(function() {input.focus();}, 220);}
        }        
      }
  }

  close_attr_personne(event){
    if(event.which == 37){
      const tdParent = event.target.closest('td');
      const iconElement = tdParent.querySelector('.icon-plus-personne');
      const nextElement = iconElement.closest('.select-personne').nextElementSibling;
      if (iconElement.classList.contains("attr-display")){
        iconElement.classList.remove('attr-display');
        iconElement.classList.remove('fa-minus');
        iconElement.classList.add('fa-plus');
        $(nextElement).hide(200)
        $(tdParent).find(".personnes_affichage div input").focus()
        $(".datepicker ").remove()
      }else{return;}
    }
  }

}